import React from 'react'
import { branch, Price } from '../../../../helpers/utility'
import { renderNothing } from 'recompose'

import './order-invoice.scss'

const OrderInvoice = ({ order, userType }) => {
  const showCountColumn = userType !== 'STUDENT'

  return (
    <table className="order-receipt">
      <thead>
        <tr>
          <th>عنوان</th>
          <th>قیمت واحد</th>
          {showCountColumn && <th>تعداد</th>}
          <th>قیمت نهایی</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td>{order.service.title}</td>
          <td>
            <Price>{order.amount}</Price>
          </td>

          {showCountColumn && <td>{order.owners.length}</td>}

          <td>
            <Price>{order.paid}</Price>
          </td>
        </tr>
      </tbody>
    </table>
  )
}

export default branch(({ order }) => Boolean(order), OrderInvoice, renderNothing)



// WEBPACK FOOTER //
// ./src/components/common/credit/PaymentSuccess/OrderInvoice.js